export const formatDate = (dateString) => {
  const dateObj = new Date(dateString);
  const day = String(dateObj.getUTCDate()).padStart(2, '0');
  const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
  const year = dateObj.getUTCFullYear();
  return `${day}-${month}-${year}`;
};


export function formatTime(utcString) {
  const date = new Date(utcString);
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const formattedMinutes = minutes.toString().padStart(2, "0");
  return `${hours}:${formattedMinutes} ${period}`;
}

export const getLocation = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });
      },
      (error) => {
        console.log("Location denied/error", error);
        resolve(null); // ❗ login fail nahi hoga
      }
    );
  });

export const convertMs = (ms) => {
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor(ms / 1000) % 60;

  return { hours, minutes, seconds };
};

export const getCurrentServerTime = (lastServerTime,lastClientSyncTime) => {
  if (!lastServerTime || !lastClientSyncTime) {
    return null;
  }
  const elapsed = Date.now() - lastClientSyncTime;

  return new Date(lastServerTime.getTime() + elapsed);
};